"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketOverviewPersonalShoppingAdvice = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const andes_react_1 = require("@yonderland/andes-react");
const andes_icons_1 = require("@yonderland/andes-icons");
const common_components_1 = require("@as-react/common-components");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const GeneralConstants_1 = require("../../../constants/GeneralConstants");
const react_hook_form_1 = require("react-hook-form");
const yup_1 = require("@hookform/resolvers/yup");
const Yup = tslib_1.__importStar(require("yup"));
const FormValidationUtil_1 = tslib_1.__importDefault(require("../../../util/FormValidationUtil"));
const FormField_1 = require("../../form/FormField");
const react_redux_1 = require("react-redux");
const BasketSelector_1 = require("../../../redux/basket/selectors/BasketSelector");
const react_1 = require("react");
const LocalStorageUtil_1 = tslib_1.__importDefault(require("../../../util/LocalStorageUtil"));
const StorageKeysConstants_1 = require("../../../constants/StorageKeysConstants");
const common_types_1 = require("@as-react/common-types");
const common_utils_1 = require("@as-react/common-utils");
const BasketOverviewPersonalShoppingAdvice = () => {
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.checkout, i18nConstants_1.I18N_NAMESPACES.form]);
    const basketStatus = (0, react_redux_1.useSelector)((0, BasketSelector_1.makeGetBasketStatusState)());
    const [personalShoppingAdvice, setPersonalShoppingAdvice] = (0, react_1.useState)();
    const isPersonalShoppingAdviceEnabled = () => !!personalShoppingAdvice && personalShoppingAdvice === 'true';
    const { defaultRequestParams, servicesEndpoint, root, isShopLanding } = (0, common_components_1.useAemConfig)();
    const { sendPersonalShoppingAdviceMail } = (0, common_queries_1.basketMutations)({ servicesEndpoint, defaultRequestParams });
    const { mutate: sendPersonalShoppingAdviceMailMutation, isPending, isSuccess, } = (0, react_query_1.useMutation)(sendPersonalShoppingAdviceMail);
    const validationSchema = Yup.object({
        email: Yup.string()
            .required(t(`${i18nConstants_1.I18N_NAMESPACES.account}:delivery.required`))
            .matches(FormValidationUtil_1.default.emailPatternRegex, t(`${i18nConstants_1.I18N_NAMESPACES.general}:email.error.invalid`)),
    });
    const formProps = (0, react_hook_form_1.useForm)({
        defaultValues: { email: '' },
        mode: 'onTouched',
        shouldFocusError: true,
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    (0, react_1.useEffect)(() => {
        if (isShopLanding) {
            const value = LocalStorageUtil_1.default.getJsonItem(StorageKeysConstants_1.PERSONAL_SHOPPING_ADVICE_STORAGE_KEY);
            if (value) {
                setPersonalShoppingAdvice(value);
            }
        }
    }, []);
    const handleSubmit = ({ email }) => {
        sendPersonalShoppingAdviceMailMutation(email, {
            onSuccess: () => setTimeout(() => (window.location.href = (0, common_utils_1.getHomepageUrl)(root)), GeneralConstants_1.DELAY.DELAY_3000),
            onError: error => {
                var _a;
                const { response } = error;
                formProps.setError('email', { message: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message });
            },
        });
    };
    if (!isShopLanding || !isPersonalShoppingAdviceEnabled() || basketStatus !== common_types_1.BasketStatus.READY) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, Object.assign({}, formProps, { children: (0, jsx_runtime_1.jsx)("form", { onSubmit: formProps.handleSubmit(handleSubmit), noValidate: true, name: "personal-shopping-advice-form", children: (0, jsx_runtime_1.jsxs)(andes_react_1.StackBlock, { gap: "4", children: [(0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "titleM", children: t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.basket.psa.title`) }), (0, jsx_runtime_1.jsx)(FormField_1.FormField, { name: "email", children: (_a) => {
                            var _b = _a.fieldProps, { ref } = _b, options = tslib_1.__rest(_b, ["ref"]), { error } = _a;
                            return ((0, jsx_runtime_1.jsx)(andes_react_1.TextField, Object.assign({}, options, { label: t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.email_recognition.email.label`), name: "email", id: "email", autoComplete: "email", type: "email", error: error })));
                        } }), (0, jsx_runtime_1.jsx)(andes_react_1.ButtonAlpha, { type: "submit", theme: "branded", variant: "secondary", state: isPending || isSuccess ? 'loading' : 'interactive', text: t(`${i18nConstants_1.I18N_NAMESPACES.form}:form.send`), iconRight: { size: 'sm', source: andes_icons_1.ArrowRightIcon }, fullWidth: true })] }) }) })));
};
exports.BasketOverviewPersonalShoppingAdvice = BasketOverviewPersonalShoppingAdvice;
